// RouteLocaleManager.js
import LocaleManager from '@/i12e/i18n/localeManager';

const RouteLocaleManager = {
  /**
   * Middleware for Vue Router to handle locale in route parameters.
   * Ensures that the locale in the URL is valid and sets the application's
   * locale accordingly.
   * If the locale in the URL is not supported, redirects to a default locale.
   *
   * @param {Object} to - The target Route Object being navigated to.
   * @param {Object} from - The current route being navigated away from.
   * @param {Function} next - The function to resolve the navigation.
   */
  routeMiddleware(to, from, next) {
    const paramLocale = to.params.locale;

    if (LocaleManager.isLocaleSupported(paramLocale)) {
      LocaleManager.activeLocale = paramLocale;
      next();
    } else {
      next({
        name: to.name,
        params: { locale: LocaleManager.activeLocale }
      });
    }
  },

  /**
   * Enhances a route object with the current locale.
   * Useful for programmatic navigation where the locale needs to be included
   * in the route.
   *
   * @param {Object} to - The route object to be enhanced.
   * @return {Object} - The enhanced route object with the current locale.
   */
  i18nRoute(to) {
    return {
      ...to,
      params: { locale: LocaleManager.activeLocale, ...to.params }
    };
  }
};

export default RouteLocaleManager;
